import React from 'react';
import { Card } from './ui/card';
import { ShoppingCart, FileText, CheckCircle, Truck } from 'lucide-react';
import { mockOrderSteps } from '../data/mock';

const iconMap = {
  ShoppingCart,
  FileText,
  CheckCircle,
  Truck
};

const HowToOrder = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-burgundy mb-6">
            Comment commander ?
          </h2>
          <p className="text-lg text-gray-700 max-w-2xl mx-auto">
            Commande simple, rapide et claire en quelques étapes
          </p>
        </div>

        {/* Steps */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {mockOrderSteps.map((step, index) => {
              const Icon = iconMap[step.icon];
              return (
                <div key={step.id} className="relative">
                  <Card className="p-8 bg-white border-2 border-gray-100 hover:border-burgundy/30 hover:shadow-xl transition-all duration-300 group text-center h-full animate-fade-in-up"
                    style={{ animationDelay: `${index * 100}ms` }}
                  >
                    {/* Step Number */}
                    <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-10 h-10 bg-burgundy text-white rounded-full flex items-center justify-center font-bold text-lg shadow-lg group-hover:scale-110 transition-transform">
                      {step.id}
                    </div>

                    {/* Icon */}
                    <div className="mb-6 mt-4 flex justify-center">
                      <div className="p-4 bg-gold/20 rounded-2xl group-hover:bg-gold group-hover:scale-110 transition-all duration-300">
                        <Icon size={32} className="text-burgundy group-hover:text-white transition-colors" />
                      </div>
                    </div>

                    {/* Title */}
                    <h3 className="text-xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>

                    {/* Description */}
                    <p className="text-gray-600 text-sm">
                      {step.description}
                    </p>
                  </Card>

                  {/* Connector Arrow (hidden on last item and mobile) */}
                  {index < mockOrderSteps.length - 1 && (
                    <div className="hidden lg:block absolute top-1/2 -right-4 transform translate-x-1/2 -translate-y-1/2 text-gold">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToOrder;
